import React from "react";
import { Avatar } from "@jkast90/kast-common/ui";
import { useNavigate } from "react-router-dom";
import {
  pictureSrc,
  type Profile as KindlyProfile,
} from "../../services/kindlyApi";
import { profilePath } from "../../../profile/profilePath";
import { ProfileHover } from "./ProfileHover";
import styles from "./UserBadge.module.css";

interface Profile {
  id: number;
  first_name: string;
  last_name: string;
  email?: string;
  picture?: KindlyProfile["picture"];
  profile_picture?: string;
}

interface UserBadgeProps {
  user: Profile;
  onClick?: (userId: number) => void;
  showFullName?: boolean;
}

export const UserBadge: React.FC<UserBadgeProps> = ({
  user,
  onClick,
  showFullName = true,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(user.id);
    } else {
      navigate(profilePath(user.id));
    }
  };

  const displayName = showFullName
    ? `${user.first_name} ${user.last_name}`
    : user.first_name;

  return (
    <span className={styles.userBadge} onClick={handleClick}>
      <ProfileHover
        name={`${user.first_name} ${user.last_name}`}
        src={pictureSrc(user)}
      >
        <Avatar name={displayName} src={pictureSrc(user)} size="xs" />
      </ProfileHover>
      {displayName}
    </span>
  );
};
